export default {
    name: 'common',
    initialState: {
        wh: {},
        shrink: true,
        chat: {},
        imgChats: [],
        videoChats: [],
        imgChatsParameter: {
            page: 1,
            pageSize: 10,
            hasNextPage: true,
        },
        videoChatsParameter: {
            page: 1,
            pageSize: 10,
            hasNextPage: true,
        },
    },
    reducers: {
        setWH: (state, { payload }) => {
            state.wh = payload;
        },
        setShrink: (state, { payload }) => {
            state.shrink = payload;
        },

        setActivatedChat: (state, { payload }) => {
            state.chat = payload;
        },

        setImgChats: (state, { payload }) => {
            state.imgChats = payload;
        },
        setVideoChats: (state, { payload }) => {
            state.videoChats = payload;
        },

        setImgChatsParameter: (state, { payload }) => {
            state.imgChatsParameter = payload;
        },
        setVideoChatsParameter: (state, { payload }) => {
            state.videoChatsParameter = payload;
        },
    },
};
